export default "__VITE_ASSET__B1D_faej__"